module.exports = __webpack_public_path__ + "img/workerMNG.8db0666f.svg";